module.exports = __webpack_public_path__ + "static/media/cargo.5a0227bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cargo.svg
// module id = 615
// module chunks = 0